export const DEFAULT_APP_SUMO_PLAN_NAME = "Lifetime Jugl Basic";

export const DEFAULT_APP_SUMO_SEATS_COUNT = 20;
